export const getters = {
    LIST: (state) => state.articles
}